import { updateKeyInStore } from 'App';
import * as Yup from 'yup';
import { CurrentAddressStateValues, updateKey } from './slice';
import { countries } from 'countries';
import { Validators } from 'utils/Validators';

export const fields: IBaseField<keyof CurrentAddressStateValues>[] = [
  {
    type: 'radio',
    name: 'livingInUs',
    label: 'As of the selected year, are you living in the US?',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    type: 'text',
    name: 'currentMailingAddress',
    label: 'Current Mailing Address (where you receive physical mail)',
    subLabel: () => <p>If you live abroad, consider a virtual mailbox</p>,
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'Current Mailing Address',
  },
  {
    type: 'text',
    name: 'city',
    label: 'City',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'City',
  },
  {
    type: 'text',
    name: 'state',
    label: 'State',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'State',
  },
  {
    type: 'text',
    name: 'zipcode',
    label: 'Zip/Postal Code',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    placeholder: 'zipcode',
  },

  {
    type: 'country',
    name: 'country',
    label: 'Country',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    type: 'radio',
    name: 'livedAtAboveAdressThisYear',
    label: 'Did you live at the above address in the selected year?',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        type: 'text',
        name: 'streetAddressThisYear',
        label:
          'What was your street Address in the selected year? (if not the same as above)',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        predicate: (value) => value === 'no',
        placeholder: 'street Address',
      },
      {
        type: 'text',
        name: 'cityThisYear',
        label: 'City',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        predicate: (value) => value === 'no',
        placeholder: 'City',
      },
      {
        type: 'text',
        name: 'stateThisYear',
        label: 'State',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        predicate: (value) => value === 'no',
        placeholder: 'State',
      },
      {
        type: 'text',
        name: 'zipcodeThisYear',
        label: 'Zip/Postal Code',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        predicate: (value) => value === 'no',
        placeholder: 'Zip/Postal Code',
      },

      {
        type: 'country',
        name: 'countryThisYear',
        label: 'Country',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        predicate: (value) => value === 'no',
      },
    ],
  },
  {
    type: 'radio',
    name: 'liveWithSpouse',
    label: 'Do you live with your spouse?',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        type: 'text',
        name: 'spouseAddress',
        label: 'Spouse address',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        predicate: (value) => value === 'no',
        placeholder: 'Spouse address',
      },
    ],
  },
];
const requiredIfNotThisYear = (schema: Yup.AnySchema) => {
  return schema.when('livedAtAboveAdressThisYear', {
    is: 'no',
    then: schema.required('required'),
  });
};

export const validationSchema = Yup.object().shape({
  currentMailingAddress: Yup.string().trim().nullable().required('required'),
  country: Yup.string().trim().nullable().required('required'),
  zipcode: Validators.zipCode.required('required'),
  state: Yup.string().trim().nullable().required('required'),
  city: Yup.string().trim().nullable().required('required'),
  streetAddressThisYear: requiredIfNotThisYear(Yup.string().nullable().trim()),
  cityThisYear: requiredIfNotThisYear(Yup.string().nullable().trim()),
  stateThisYear: requiredIfNotThisYear(Yup.string().nullable().trim()),
  zipcodeThisYear: requiredIfNotThisYear(Validators.zipCode),
  countryThisYear: requiredIfNotThisYear(Yup.string().nullable().trim()),
});
